module.exports = __webpack_public_path__ + "static/media/ic_document_note.00a685fe.svg";